import BlogLayout from '../../layout/BlogLayout'
import Image1 from '../../assets/blog/article-4/1.webp'
import Image2 from '../../assets/blog/article-4/2.webp'
import Image3 from '../../assets/blog/article-4/3.webp'
import Image4 from '../../assets/blog/article-4/4.webp'
import Image5 from '../../assets/blog/article-4/5.webp'
import Image6 from '../../assets/blog/article-4/6.webp'
// import Image7 from '../../assets/blog/article-4/7.webp'

const Article4 = () => {
  return (
    <BlogLayout
      category='Taller'
      title='HumanIA en VIDA Cowork: un encuentro para pensar el futuro con estrategia'
    >
      <p>
        El jueves pasado recibimos en nuestra sede Wast a <strong>HumanIA Comunidad</strong>,
        el proyecto creado por Nicolás Seleme y Melisa Campos que busca conectar personas y
        tecnología, generando espacios donde las conversaciones sobre IA salgan del ruido y
        se transformen en acción concreta.
      </p>

      <p>
        El encuentro reunió a profesionales de RRHH, tecnología, gestión y liderazgo. Y hubo
        algo que nos sorprendió a todos: <strong>1 de cada 3 asistentes pertenecía al mundo tech</strong>,
        lo que abrió diálogos profundos, genuinos y necesarios sobre los desafíos actuales,
        los miedos compartidos y las oportunidades que la inteligencia artificial ya está
        generando dentro de las organizaciones.
      </p>
      <img src={Image1} alt="Blog" className="img--medium" />
      <img src={Image5} alt="Blog" className="img--medium" />
      <p className='blog-subtitle'>¿De qué se trató la jornada?</p>
      <p>
        HumanIA propuso un espacio íntimo y práctico para reflexionar sobre un tema urgente:
        <strong>¿Las empresas están integrando IA con estrategia o simplemente reaccionando sobre la marcha?</strong>
      </p>
      <img src={Image4} alt="Blog" className="img--large" />
      <p>
        Para ordenar esta conversación, Nicolás y Melisa presentaron un <strong>mini marco de trabajo</strong>
        que ayuda a comprender cómo implementar IA dentro de los equipos sin improvisar. Además, cada
        participante recibió un <strong>Gems personalizado</strong>, una herramienta diseñada para que
        cada persona pueda describir su situación actual y obtener un plan inicial adaptado a su contexto.
      </p>
      <img src={Image2} alt="Blog" className="img--large" />
      <p>
        El evento también incluyó casos reales de empresas que ya están trabajando con IA de manera
        estratégica, mostrando resultados concretos y los pasos que siguieron para lograrlo.
      </p>
      <p className='blog-subtitle'>Lo que los participantes se llevaron</p>
      <ul>
        <li>
          <p><strong>Una lógica clara y accionable</strong>para empezar a integrar IA en una empresa.</p>
        </li>
        <li>
          <p><strong>Ideas prácticas</strong>para aplicar desde el día siguiente..</p>
        </li>
        <li>
          <p><strong>Conexiones valiosas</strong>con profesionales que están transitando los mismos desafíos.</p>
        </li>
        <li>
          <p>Un espacio seguro para conversar sin juicios, compartir inquietudes y descubrir caminos posibles.</p>
        </li>
      </ul>
      <img src={Image3} alt="Blog" className="img--small" />
      <p className='blog-subtitle'>En VIDA Cowork nos encanta crear estos espacios</p>
      <p>
        Para nosotros, abrir las puertas a iniciativas como HumanIA es parte de nuestra esencia:{' '}
        <strong>aliarnos con comunidades que están construyendo un futuro lleno de oportunidades, colaboración
        y crecimiento para las personas y las organizaciones</strong>.
      </p>
      <img src={Image6} alt="Blog" className="img--small" />
      <p>
        Creemos en el poder de los encuentros que inspiran, que conectan y que ayudan a pensar mejor.
        Por eso, este es apenas uno de los muchos espacios que seguiremos impulsando
      </p>
    </BlogLayout>
  )
}

export default Article4